module.exports = __webpack_public_path__ + "static/media/setupannoucementicon.6cabf085.svg";